import { Navigate, createFileRoute } from '@tanstack/react-router';

import { routes } from 'shared/routes';

import { ResetPassword, resetPasswordSearchSchema } from 'features/auth/ResetPassword';

export const Route = createFileRoute('/auth/_auth/reset-password/')({
  component: ResetPasswordRoute,
  validateSearch: resetPasswordSearchSchema,
  errorComponent: () => <Navigate to={routes.forgotPassword()} />
});

function ResetPasswordRoute() {
  const { email, reason } = Route.useSearch();

  return <ResetPassword email={email} reason={reason} />;
}
